import React from 'react'
import { IProspectsCardsProps } from '../ProspectsCards'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { LayoutCardsColumns } from '../ProspectsCards.styles'
import Dropdown from 'src/components/common/Dropdown/Dropdown'
import { useSelector } from 'react-redux'
import { selectProspects } from 'src/redux/prospects/prospectsSlice'
import { useHandleProspectCS } from './ProspectsCS.helper'

const ProspectsCS = ({ prospect, loading }: IProspectsCardsProps) => {
    const { catalogs: { attentions, typification, recommendations, customer_success } } = useSelector(selectProspects);
    const hasCatalogs = customer_success.length + attentions.length + typification.length + recommendations.length > 0;
    const isClosed = ![null, undefined, 2].includes(prospect?.typification_id);
    const { onChangeAssignedUser, onChangeAttention, onChangeRecommendation, onChangeTypification, loadingSelection } = useHandleProspectCS(prospect);


    if (loading || loadingSelection || !hasCatalogs) return (
        <>
            <SkeletonLoader width='219px' height='18px' count={3} />
            <SkeletonLoader width='140px' height='18px' />
        </>
    )
    return (
        <LayoutCardsColumns>
            <div className='containerLabel'>
                <span className="label">Asignación:</span>
                <Dropdown
                    arraySelect={customer_success}
                    currentSelected={customer_success.findIndex(item => item.value === prospect.assigned_user_id) + 1}
                    colorSelect={'blue'}
                    isDisabled={Boolean(prospect.assigned_user_id) || isClosed}
                    nullMessage='Sin asignar'
                    onChangeSelect={onChangeAssignedUser}
                />
            </div>
            <div className='containerLabel'>
                <span className="label">Tipo de Atención:</span>
                <Dropdown
                    arraySelect={attentions}
                    currentSelected={attentions.findIndex(item => item.value === prospect.attention_id) + 1}
                    colorSelect={'grey'}
                    isDisabled={isClosed}
                    nullMessage='Sin asignar'
                    onChangeSelect={onChangeAttention}
                />
            </div>
            <div className='containerLabel'>
                <span className="label">Recomendación:</span>
                <Dropdown
                    arraySelect={recommendations}
                    currentSelected={recommendations.findIndex(item => item.value === prospect.recommendation_id) + 1}
                    colorSelect={'ocean'}
                    isDisabled={isClosed}
                    nullMessage='Sin asignar'
                    onChangeSelect={onChangeRecommendation}
                />
            </div>
            <div className='containerLabel'>
                <span className="label">Tipificación:</span>
                <Dropdown
                    arraySelect={typification}
                    currentSelected={typification.findIndex(item => item.value === prospect.typification_id) + 1}
                    colorSelect={'grey'}
                    nullMessage='Sin asignar'
                    isDisabled={isClosed}
                    onChangeSelect={onChangeTypification}
                />
            </div>
        </LayoutCardsColumns>
    )
}

export default ProspectsCS